import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import toolSlugMap from "../data/tool-slugs.json"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function toolIdToSlug(value: string): string {
  if (!value) return ""

  const manualSlug = (toolSlugMap as Record<string, string>)[value]
  if (manualSlug) return manualSlug

  return value
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[\\/:?*"<>|]/g, "")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")
}

export function isFreePricing(pricing: string): boolean {
  const normalized = pricing.trim().toLowerCase()
  return normalized === 'free' || normalized === '免费'
}

export function slugToToolId(slug: string): string | null {
  // 首先检查反向映射
  const reverseMap: Record<string, string> = {}
  Object.entries(toolSlugMap as Record<string, string>).forEach(([id, s]) => {
    reverseMap[s] = id
  })
  
  if (reverseMap[slug]) {
    return reverseMap[slug]
  }
  
  // 如果没有找到，尝试从 slug 还原（这只是猜测，可能不准确）
  // 返回 null 让调用者处理
  return null
}
